module.exports = __webpack_public_path__ + "static/media/003.94e52c61.jpg";